import React from 'react';
import { Shield } from 'lucide-react';
import { SEO } from '../../components/SEO';

function PravilaPrivatnosti() {
  return (
    <>
      <SEO 
        title="Pravila Privatnosti | Online Kalkulator"
        description="Pravila privatnosti Online Kalkulatora. Saznajte kako štitimo vaše osobne podatke i koje informacije prikupljamo."
        canonicalUrl="/pravila-privatnosti"
      />
      <div className="max-w-4xl mx-auto px-4">
        <div className="flex items-center justify-center gap-3 mb-6">
          <Shield className="w-8 h-8 text-blue-600" />
          <h1 className="text-3xl font-bold text-gray-800 text-center">Pravila Privatnosti</h1>
        </div>

        <div className="bg-white rounded-xl shadow-lg p-8">
          <div className="prose max-w-none">
            <p className="text-gray-600 mb-6">
              Posljednje ažuriranje: {new Date().toLocaleDateString('hr-HR')}
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Uvod</h2>
              <p className="text-gray-600">
                Online Kalkulator poštuje vašu privatnost i predani smo zaštiti vaših osobnih podataka.
                Ova Pravila privatnosti objašnjavaju kako prikupljamo, koristimo i štitimo vaše podatke
                kada koristite našu web stranicu.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Koje Podatke Prikupljamo</h2>
              <p className="text-gray-600 mb-4">
                Prikupljamo sljedeće vrste podataka:
              </p>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                <li>Podatke o korištenju web stranice</li>
                <li>IP adrese</li>
                <li>Podatke o pregledniku i uređaju</li>
                <li>Kolačiće i slične tehnologije</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Kako Koristimo Vaše Podatke</h2>
              <p className="text-gray-600 mb-4">
                Vaše podatke koristimo za:
              </p>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                <li>Pružanje i održavanje naših usluga</li>
                <li>Poboljšanje korisničkog iskustva</li>
                <li>Analizu korištenja web stranice</li>
                <li>Sprječavanje zlouporabe</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Kolačići</h2>
              <p className="text-gray-600">
                Koristimo kolačiće i slične tehnologije za praćenje aktivnosti na našoj web stranici i
                zadržavanje određenih informacija. Kolačići su datoteke s malom količinom podataka koje
                mogu uključivati anonimni jedinstveni identifikator.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Google AdSense</h2>
              <p className="text-gray-600 mb-4">
                Naša web stranica koristi Google AdSense, uslugu za prikazivanje oglasa koju pruža Google Inc. Google AdSense koristi kolačiće i druge tehnologije za prikupljanje podataka o vašem korištenju naše web stranice.
              </p>
              <p className="text-gray-600 mb-4">
                Google AdSense može koristiti i pohranjivati sljedeće podatke:
              </p>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                <li>Informacije o vašem uređaju i pregledniku</li>
                <li>IP adresu</li>
                <li>Podatke o klikovima i prikazima oglasa</li>
                <li>Geografsku lokaciju</li>
                <li>Kolačiće za personalizaciju oglasa</li>
              </ul>
              <p className="text-gray-600 mt-4">
                Ovi podaci pomažu u prikazivanju relevantnijih oglasa i mjerenju učinkovitosti oglašavanja. Google može koristiti prikupljene podatke za vlastite potrebe u skladu sa svojom politikom privatnosti. Za više informacija o Google AdSense pravilima privatnosti, posjetite <a href="https://policies.google.com/privacy" target="_blank" rel="nofollow noopener noreferrer" className="text-blue-600 hover:underline">Google Pravila privatnosti</a>.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Sigurnost Podataka</h2>
              <p className="text-gray-600">
                Sigurnost vaših podataka nam je važna, ali imajte na umu da nijedna metoda prijenosa
                preko interneta ili metoda elektroničkog pohranjivanja nije 100% sigurna. Iako se
                trudimo koristiti komercijalno prihvatljiva sredstva za zaštitu vaših osobnih podataka,
                ne možemo jamčiti njihovu apsolutnu sigurnost.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Vaša Prava</h2>
              <p className="text-gray-600 mb-4">
                Imate sljedeća prava vezana uz vaše osobne podatke:
              </p>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                <li>Pravo na pristup vašim osobnim podacima</li>
                <li>Pravo na ispravak netočnih podataka</li>
                <li>Pravo na brisanje vaših podataka</li>
                <li>Pravo na ograničenje obrade</li>
                <li>Pravo na prigovor na obradu</li>
                <li>Pravo na prenosivost podataka</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Promjene Pravila Privatnosti</h2>
              <p className="text-gray-600">
                Možemo ažurirati naša Pravila privatnosti s vremena na vrijeme. Obavijestit ćemo vas o
                svim promjenama objavljivanjem novih Pravila privatnosti na ovoj stranici i ažuriranjem
                datuma "Posljednje ažuriranje" na vrhu ovih Pravila privatnosti.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Kontakt</h2>
              <p className="text-gray-600">
                Ako imate bilo kakvih pitanja o ovim Pravilima privatnosti, možete nas kontaktirati:
              </p>
              <ul className="list-disc list-inside text-gray-600 mt-4">
                <li>E-poštom: kontakt@backspace-media.com</li>
              </ul>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default PravilaPrivatnosti;